import React, { useEffect, useMemo } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import styles from './ExcelResequence.module.css';
import { API_RESOURCE_URLS, DATE_FORMAT } from '../../constants';

import {
  buildErrorMessage,
  fetchSequenceForDatePlantAndLine,
} from '../../apis/calls';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { ResequenceFinalPreview } from '../../components';
import { API } from '../../apis/api';

const ExcelResequence = () => {
  const { ISODate } = useParams();
  const history = useHistory();
  const { showInternalError , showError } = usePopupManager();
  const location = useLocation();
  const { extractedData } = location.state;

  // Update extractedData directly without setExtractedData
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadSequenceDataForDatePlantAndLine = async (date, plant, line) => {
    const dateString = date.format(DATE_FORMAT.ISO);
    try {
    
    } catch (err) {
      console.error('failed to load sequence err:' + buildErrorMessage(err));
      showInternalError();
    }
  };

  const currentDate = useMemo(() => moment(ISODate, DATE_FORMAT.ISO), [
    ISODate,
  ]);

  useEffect(() => {
    if (ISODate && plant?.value && line?.value) {
      const date = moment(ISODate, DATE_FORMAT.ISO);
      loadSequenceDataForDatePlantAndLine(date, plant.value, line.value);
    }
  }, [ISODate, line, loadSequenceDataForDatePlantAndLine, plant]);

  const redirectBackToPreviews = () => history.push('/sequence-previews');

  const updateSequenceOrder = (sequence, date) => {
    // Update extractedData according to sequence
    const updatedData = extractedData.map(item => {
      const seqItem = sequence.find(seq => seq.vc === item.vc);
      if (seqItem) {
        return {
          ...item,
          serialNumber: seqItem.serialNumber,
          category: seqItem.category,
          market: seqItem.market,
          countryCode: seqItem.countryCode,
          defence: seqItem.defence,
          fbv: seqItem.fbv,
          fbvVendorCode: seqItem.fbvVendorCode,
          buildCardNumber: seqItem.buildCardNumber,
          powerSteering: seqItem.powerSteering,
          colourCode: seqItem.colourCode,
          evrNumber:seqItem.evrNumber,
          shiftId: null,
          shiftName: null,
        };
      }
      return item;
    });

    // Update extractedData state directly
    location.state.extractedData = updatedData;

    // Perform API call with updated extractedData
    return API.put(API_RESOURCE_URLS.VC_SEQUENCE, {
      plant: plant.value,
      line: line.value,
      date: date.format(DATE_FORMAT.ISO),
      vcSequencePlans: sequence.map((seq, index) => {
        return {
          serialNumber: index + 1,
          vc: seq.vc,
          category: seq.category,
          market: seq.market,
          countryCode: seq.countryCode,
          defence: seq.defence,
          fbv: seq.fbv,
          fbvVendorCode: seq.fbvVendorCode,
          buildCardNumber: seq.buildCardNumber,
          powerSteering: seq.powerSteering,
          colourCode: seq.colourCode,
          evrNumber:seq.evrNumber,
          shiftId: null,
          shiftName: null,
        };
      }),
    });
  };

  const saveSequence = sequence => {
    updateSequenceOrder(sequence, currentDate)
      .then(redirectBackToPreviews)
      .catch(error => {
        console.error('Error saving sequence', error);
        showError({
          contextText: `One or more vc variants in the update plan is not the same as the existing plan.`,
          error: error,
        });
      });
  };

  return (
    <div className={styles.container}>
      <ResequenceFinalPreview
        date={currentDate}
        sourceData={extractedData}
        lineName={line.label}
        handleConfirm={saveSequence}
        handleBack={redirectBackToPreviews}
      />
    </div>
  );
};

ExcelResequence.propTypes = {};

export default ExcelResequence;